<template>
  <div class="page">
    <div class="header">
      <div class="content header__content">
        <div class="title">杭州启汇科技有限公司</div>
      </div>
      <div class="bg1"></div>
      <div class="bg2"></div>
      <div class="bg3"></div>
      <div class="content__title">Create Something.</div>
    </div>
    <div class="container">
      <div class="content">
        <div class="container__tit">我们的产品</div>
        <div class="container__navlist">
          <div
            class="container__navItem"
            @click="activeIndex = ind"
            :class="ind == activeIndex ? 'container__navItem--active' : ''"
            v-for="(v, ind) in list"
          >
            {{ v.name }}
          </div>
        </div>
        <div class="app__content">
          <div class="app__intr">
            <div class="app__name">{{ list[activeIndex].name }}</div>
            <div class="app__tit">{{ list[activeIndex].intr }}</div>
            <div class="app__qrcode">
              <img class="qrcode" :src="list[activeIndex].qrCode" />
              <div class="app__alt">请使用微信扫描小程序码体验</div>
            </div>
          </div>
          <div class="app__mobile">
            <img class="app__demo" :src="list[activeIndex].appImage" />
          </div>
        </div>
      </div>
    </div>
    <!-- <div class="about">
      <div class="content">
        <div class="container__tit">定制开发</div>
        <div class="feature__list">
          <div class="feature__item">
            <img
              :src="
                require('@/assets/image/qihui_home_icon_miniprograme@2x.png')
              "
              class="feature__icon"
            />
            <div class="feature__name">小程序开发</div>
          </div>
          <div class="feature__item">
            <img
              :src="require('@/assets/image/qihui_home_icon_wechat@2x.png')"
              class="feature__icon"
            />
            <div class="feature__name">微信定制开发</div>
          </div>
          <div class="feature__item">
            <img
              :src="require('@/assets/image/qihui_home_icon_h5@2x.png')"
              class="feature__icon"
            />
            <div class="feature__name">H5开发</div>
          </div>
          <div class="feature__item">
            <img
              :src="require('@/assets/image/qihui_home_icon_wechat@2x.png')"
              class="feature__icon"
            />
            <div class="feature__name">网站开发</div>
          </div>
        </div>
      </div>
    </div> -->
    <div class="footer">
      <div class="content">
        <div class="footer__tit">
          联系我们<a
            href="mailto:elfinbook@hzqihui.cn"
            style="padding-left: 20px"
            >邮箱：elfinbook@hzqihui</a
          >
          <span style="padding-left: 20px"
            >地址：浙江省杭州市西湖区西湖广告大厦804</span
          >
        </div>
        <div class="footer__copyright">
          @{{ year || 2022 }} 杭州启汇科技有限公司
          <span class="footer__ipc"
            ><a
              href="http://beian.miit.gov.cn/"
              target="_blank"
              style="padding-left: 20px"
              >浙ICP备15028861号</a
            >
            <a
              href="http://www.beian.gov.cn/"
              class="footer__safenum"
              target="_blank"
              >浙公网安备 33010602010744号</a
            ></span
          >
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  created() {
    document.title = '杭州启汇科技有限公司';
    function parseUrlParams(url) {
      const params = {};
      const queryString = url.split('?')[1];

      if (queryString) {
        const keyValuePairs = queryString.split('&');

        keyValuePairs.forEach((pair) => {
          const [key, value] = pair.split('=');
          params[key] = decodeURIComponent(value);
        });
      }

      return params;
    }
    let params = parseUrlParams(window.location.href);
    if ([1, 2, 3, 4].indexOf(+params.a) > -1) {
      this.activeIndex = +params.a;
    }
  },
  props: {},
  data() {
    return {
      activeIndex: 0,
      list: [
        {
          name: 'Elfinbook易飞',
          intr: '口袋里的收集高清扫描仪！提供文件扫描、证件扫描、图片转文字、图片转表格、PDF转换等服务。',
          qrCode: require('@/assets/image/qihui_home_image_elfinbookqrcode@2x.png'),
          appImage: require('@/assets/image/qihui_home_image_elfinbookpage@2x.png')
        },
        {
          name: '易飞群接龙',
          intr: '发个群接龙，高效收集信息。安全易用、简单实用的群接龙工具！提供填表、收集、签到、打卡、通知、报名、预约、答题、问卷等服务。',
          qrCode: require('@/assets/image/qihui_home_image_solitaireqrcode@2x.png'),
          appImage: require('@/assets/image/qihui_home_image_solitairepage@2x.png')
        },
        {
          name: '易飞拼图',
          intr: '简单实用的拼图小程序！提供布局拼图、海报拼图、拼长图、拼截屏等服务。',
          qrCode: require('@/assets/image/qihui_home_image_jointqrcode@2x.png'),
          appImage: require('@/assets/image/qihui_home_image_jointpage@2x.png')
        },
        {
          name: '易飞AI抠图',
          intr: '基于顶尖AI智能引擎的抠图小程序！提供抠图、图片换背景、图片去水印、证件照制作等服务。',
          qrCode: require('@/assets/image/qihui_home_image_cutoutqrcode@2x.png'),
          appImage: require('@/assets/image/qihui_home_image_cutoutpage@2x.png')
        },
        {
          name: '形白证件照',
          intr: '专业的证件照制作平台，让您足不出户，在线轻松get各类证件照片！提供证件照制作、换底色等服务。',
          qrCode: require('@/assets/image/xingbai.png'),
          appImage: require('@/assets/image/qihui_home_image_idpage@2x.png')
        }
      ],
      year: new Date().getFullYear()
    };
  },
  methods: {}
};
</script>

<style lang="scss" scoped>
.header {
  height: 680px;
  position: relative;
  background: linear-gradient(360deg, #f4f4f4 0%, #407ab3 100%);
}
.bg1 {
  position: absolute;
  top: 0;
  height: 580px;
  width: 100%;
  left: 0;
  // background: linear-gradient(360deg, #f4f4f4 0%, #407ab3 100%);
}
.bg2 {
  position: absolute;
  left: 0;
  top: 520px;
  height: 160px;
  width: 100%;
  background: linear-gradient(180deg, rgba(244, 244, 244, 0) 0%, #f8c1ae 100%);
}
.bg3 {
  position: absolute;
  left: 0;
  top: 580px;
  height: 100px;
  width: 100%;
  background: linear-gradient(180deg, rgba(244, 244, 244, 0) 0%, #9dbfe0 100%);
}
.header__content {
  position: relative;
  z-index: 2;
  height: 64px;
  margin: 0 auto;
}
.title {
  font-size: 20px;
  font-weight: bold;
  color: #fff;
  line-height: 64px;
}
.container {
}
.container__tit {
  height: 125px;
  line-height: 125px;
  font-size: 32px;
  font-weight: bold;
  text-align: center;
}
.container__navlist {
  display: flex;
  margin-bottom: 40px;
}
.container__navItem {
  cursor: pointer;
  margin-right: 18px;
  width: 144px;
  height: 40px;
  line-height: 38px;
  text-align: center;
  border-radius: 20px;
  border: 1px solid #dddddd;
  color: #666;
}
.container__navItem--active {
  border: 1px solid #666666;
  color: #222;
}
.app__content {
  display: flex;
  justify-content: space-between;
  margin-bottom: 80px;
}
.app__name {
  margin: 100px auto 40px;
  font-size: 32px;
}
.app__tit {
  font-size: 16px;
  color: #666;
  width: 684px;
  line-height: 22px;
  height: 184px;
}
.app__qrcode {
  width: 252px;
}
.qrcode {
  width: 100%;
  height: 252px;
  display: block;
}
.app__alt {
  margin-top: 20px;
  font-size: 16px;
  color: #666;
  text-align: center;
}
.app__mobile {
  width: 415px;
  height: 720px;
  display: block;
  background: url(~@/assets/image/qihui_home_image_iphone@2x.png) no-repeat 0 0 /
    100% 100%;
}
.app__demo {
  margin: 57px auto 0;
  width: 280px;
  height: 606px;
  display: block;
}

.about {
  background: #f4f4f4;
}
.feature__list {
  display: flex;
  align-content: center;
  justify-content: space-around;
  margin-top: 40px;
}
.feature__item {
  width: 200px;
  margin-bottom: 140px;
}
.feature__icon {
  width: 120px;
  height: 120px;
  display: block;
  margin: 0 auto 20px;
}
.feature__name {
  font-size: 24px;
  text-align: center;
}
.footer {
  border-top: 1px solid #e8e8e8;
  background: #f4f4f4;
  color: #999;
  padding-bottom: 80px;
}
.footer__tit {
  line-height: 63px;
  font-size: 16px;
  text-align: center;
}
.footer__copyright {
  font-size: 12px;
  text-align: center;
}
.footer__ipc {
}
.footer__safenum {
  padding-left: 25px;
  background: url(~@/assets/image/bottom_icon_police@2x.png) no-repeat 5px 0 /
    20px 20px;
}
@media (max-width: 1500px) {
  .app__tit {
    width: 450px;
  }
}
@media (max-width: 1366px) {
  .app__tit {
    width: 450px;
  }
}
.content__title {
  font-size: 48px;
  color: #fff;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
}
</style>
